import { createStore, createEvent, createEffect, combine } from 'effector';
import request from '@helpers/request';
import api from '@constants/endpoints';
import createPreloadersStore from './preloaders';
import { get } from 'lodash';
import createPaginationStore from './pagination';

export const reset = createEvent('Compalaints reason store reset');

export const getList = createEffect({
  name: 'getList',
  async handler(accountId: string) {
    const { current, pageSize } = pagination.getState();
    const data = {
      pagination: {
        pageSize,
        type: 'PAGE',
        page: (current || 1) - 1,
      },
      sort: 'createdTo,desc',
    };
    const response = await request(api.spam.getUserComplaintReasons, {
      data,
      urlParams: {
        accountId,
      },
    });
    return response;
  },
});

const { pagination, setPagination } = createPaginationStore({
  getList,
  listName: 'reasons',
  resetEvent: reset,
  bodyPath: ['data', 'body', 'page'],
});

export { setPagination };

const preloaders = createPreloadersStore([getList]);

const userComplaintReasons = createStore([])
  .on(getList.done, (state, { result }) => get(result, ['data', 'body', 'result', 'page']))
  .reset(reset);

const reasons = combine({ preloaders, userComplaintReasons, pagination, setPagination });
export default reasons;
